import React from "react";
import { FiHardDrive } from "react-icons/fi";
import DatabaseBackupSection from "./Backup/DatabaseBackupSection";
import MediaBackupSection from "./Backup/MediaBackupSection";

/**
 * Page Sauvegardes : composition fine de deux sections autonomes.
 * - « Base de données » : archives SQL de l'admin (sauvegarde, restauration, rétention,
 *   import), avec le journal des tâches replié en bas de section.
 * - « Médias » : miroir mensuel du bucket média (images, PDF) avec rotation en zip,
 *   navigateur de fichiers par mois (téléchargement unitaire) et restauration destructive
 *   sous double garde-fou.
 * Chaque section gère son propre sondage de l'API (2 s côté base, 1,5 s pendant un job média).
 */
const Backup: React.FC = () => (
	<div className="min-h-full bg-slate-50 px-4 py-5 sm:px-6 sm:py-6 lg:px-8">
		<div className="w-full space-y-5">
			<header className="flex flex-wrap items-center gap-3">
				<span className="inline-flex items-center gap-2 rounded-lg border border-slate-200 bg-white px-3 py-1.5 text-sm font-semibold text-slate-800 shadow-sm">
					<FiHardDrive className="h-4 w-4 text-sky-500" aria-hidden />
					Sauvegardes
				</span>
				<p className="text-sm text-slate-600">
					Sauvegarde et restauration de la base de données et des médias de l'admin.
				</p>
			</header>

			<DatabaseBackupSection />
			<MediaBackupSection />
		</div>
	</div>
);

export default Backup;
